import { Component, ViewContainerRef, Type, ComponentFactoryResolver } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApplicationInitService } from "./services/application-init.service";
import { LoaderService } from './services/loader.service';
import { TranslateService } from './services/translate.service';
import { AppService } from "./shared/services/app.service";
import { BaseService } from './shared/services/base.service';
@Component({
    selector: 'app-account-management-handle-url',
    template: '<div></div>',
    standalone: false
})
export class HandleRouteComponent {
  componentRef;
  init = false;

  public headerJson: any = {};
  public sidebarJson: any = [];
  breadcrumbs: Array<any>[];
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private resolver: ComponentFactoryResolver,
    private appService: AppService,
    private baseService: BaseService,
    private loaderService: LoaderService,
    private applicationInitService: ApplicationInitService,
    private translateService: TranslateService
  ) {
    console.log('HandleRouteComponent');
    console.log(this.activatedRoute.snapshot.data);
    if (this.activatedRoute.snapshot.data.application != undefined) {
      var application = this.activatedRoute.snapshot.data.application;
      this.translateService.getLanguage((ln) => {
        this.loaderService.showSpinner();
        this.appService.launguageSetup(application,ln,(info) => {
          if (info) { 
            this.loaderService.hideSpinner();
            this.setUp();
          }
        });
      })

    } else {
      console.log(this.router.config);
    }

  }

  setUp() {
    var application = this.activatedRoute.snapshot.data.application;
    var menuDef = [];
    var routeDef = [];
    var crudList = [];
    var app = '';
    if (this.activatedRoute.snapshot.data.menuDef != undefined) {
      menuDef = this.activatedRoute.snapshot.data.menuDef;
    }
    if (this.activatedRoute.snapshot.data.routeDef != undefined) {
      routeDef = this.activatedRoute.snapshot.data.routeDef;
    }
    if (this.activatedRoute.snapshot.data.crudList != undefined) {
      crudList = this.activatedRoute.snapshot.data.crudList;
    }
    if (this.activatedRoute.snapshot.data.defaultApplication != undefined) {
      app = this.activatedRoute.snapshot.data.defaultApplication;
    }
    var factories: any = this.baseService.getFactories();
    this.applicationInitService.setMenuDefinition(menuDef);
    this.applicationInitService.setRouteDefinition(routeDef);
    this.applicationInitService.setCrudList(crudList);
    this.applicationInitService.setDefaultApplication(app);
    this.appService.setApplication(application);
    // for(let key in this.router.config){
    //   if(this.router.config[key].path == application){
    var loadedRoutes = this.applicationInitService.getRoutes(application);
    for (let routeKey in loadedRoutes) {
      var singleRoute = loadedRoutes[routeKey];
      //Resolving component by name.
      if (singleRoute.component != undefined && singleRoute.data != undefined && singleRoute.data.selector != undefined && typeof singleRoute.data.selector == 'string') {
        if (factories != undefined && factories[singleRoute.data.selector] != undefined && factories[singleRoute.data.selector]) {
          (singleRoute.component as any) = factories[singleRoute.data.selector];
        }
      }

    }
    (this.activatedRoute.parent.routeConfig as any)._loadedRoutes.splice(0, 1); //removing dummy route
    (this.activatedRoute.parent.routeConfig as any)._loadedRoutes[0].children = this.applicationInitService.getRoutes(application);
    (this.activatedRoute.parent.routeConfig as any)._loadedRoutes.splice(1, (this.activatedRoute.parent.routeConfig as any)._loadedRoutes.length);

    this.router.resetConfig(this.router.config);
    this.router.navigateByUrl(this.router.url);//redirecting so that lazy loaded routes could take effect
    console.log(this.router.config);
  }
}
